import React, { PropsWithChildren, SyntheticEvent } from "react";

import css from "./DisabledOverlay.module.scss";

function preventBubbling(ev: SyntheticEvent) {
  ev.preventDefault();
  ev.stopPropagation();
}

export type DisabledOverlayProps = PropsWithChildren & {
  reason?: React.ReactNode;
};

export function DisabledOverlay(props: DisabledOverlayProps) {
  return (
    <div onClick={preventBubbling} className={css.DisabledOverlay}>
      {props.children}
    </div>
  );
}
